"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_calendar__15__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f1ca0145-13f8-4440-a8d3-d28c19b884aa",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7a715c84-59f3-409e-aad3-41af74d393d9",
    x1: 59.82,
    y1: 28.29,
    x2: 179.23,
    y2: 147.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "calendar-15-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "893a7f7f-f230-4271-b253-dbd9e5900ec0",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b1f9aa6d-a606-47a1-b4b2-95d44fe0f01e",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c9aa7e5f-71e1-4b2d-8bac-97f42bbacde3",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e9773da4-b424-4245-af93-49b40e899ddb",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1383d029-65e7-4082-b5b3-315ba93f77eb",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1436864a-2142-44c3-87a8-67aab5d1285c",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7bd8d2b8-6f93-489a-a393-6dbe4e1a06fb",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V64H24Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,24H32a8,8,0,0,0-8,8V64H168V32A8,8,0,0,0,160,24ZM52,40a4,4,0,1,1,4-4A4,4,0,0,1,52,40Zm88,0a4,4,0,1,1,4-4A4,4,0,0,1,140,40Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 144,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,52,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,140,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "3bc252f2-cc00-4754-ad00-a557d77ae46a",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,64.13l-123.33-.2h-20v.59L128.34,168H152a19,19,0,0,0,4.24-.37,16.3,16.3,0,0,0,8.52-5.64,15.86,15.86,0,0,0,3.39-9.81V64.79Z",
    transform: "translate(0 0)",
    opacity: 0.1,
    fill: "url(#7a715c84-59f3-409e-aad3-41af74d393d9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.89,24.63A7.92,7.92,0,0,1,31.19,24,7.92,7.92,0,0,0,28.89,24.63Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.54,25.37a8.1,8.1,0,0,0-1.7,1.55A8.1,8.1,0,0,1,27.54,25.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "M75.43,137.46V92.09L64,99.74l-3-4.38L76.23,84.83h5.34v52.62Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5,138.5a26,26,0,0,1-12.36-3.11,10.6,10.6,0,0,1-2.79-2.07l2.47-5.42a22.93,22.93,0,0,0,5.42,3.47,16.87,16.87,0,0,0,7.34,1.55,12.39,12.39,0,0,0,6.34-1.55,8.47,8.47,0,0,0,3.75-4.27,15.62,15.62,0,0,0,1.08-5.82q0-5.74-3.47-9t-10.48-3.31a33.43,33.43,0,0,0-4.7.28q-1.91.28-3.27.6V84.91h26.07v5.42H109.48V104a29.27,29.27,0,0,1,3.83-.32q8.69,0,13.59,4.5T131.8,121a18.57,18.57,0,0,1-2.91,10.76,13.42,13.42,0,0,1-6.86,5.5A24.51,24.51,0,0,1,114.5,138.5Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }));
}

var _default = ic_calendar__15__dark;
exports.default = _default;